import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import InputField from '../forms/InputField';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import LoaderModal from './loaderModal';
import { errorToast, successToast } from '../toast';
import { loginAction } from '../../redux/actions/authAction';

const LoginFormModal = ({ toggleModal, openForgotPasswordModal }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const initialValues = {
        email: '',
        password: '',
    };

    const validationSchema = Yup.object({
        email: Yup.string().email('Invalid email format').required('Email is required'),
        password: Yup.string().required('Password is required'),
    });

    const handleSubmit = (values, { setSubmitting }) => {
        setLoading(true);
        dispatch(loginAction(values, onLoginSuccess, onError));
        setSubmitting(false);
    };

    const onLoginSuccess = (data) => {
        setLoading(false);
        successToast(data.data.message);
        if (data.data.data.access_token) {
            localStorage.setItem('accessToken', data.data.data.access_token);
            localStorage.setItem('storeData', JSON.stringify(data.data.data?.store));
            navigate('/dashboard');
        }
    };

    const onError = (data) => {
        setLoading(false);
        const errorMsg = data.data.message || 'Unable to login. Try again later.';
        errorToast(errorMsg);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 text-black">
            <div className="bg-white shadow-lg rounded-lg px-8 pt-6 pb-8 w-96">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-2xl font-heading font-bold text-primary">Log In</h2>
                    <button onClick={toggleModal} className="text-4xl text-gray-500 hover:text-gray-800">
                        ×
                    </button>
                </div>

                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    <Form>
                        <InputField
                            label="Email"
                            name="email"
                            type="email"
                            placeholder="Enter your email"
                        />
                        <InputField
                            label="Password"
                            name="password"
                            type="password"
                            placeholder="Enter your password"
                        />
                        <button
                            type="submit"
                            className="w-full bg-primary text-white py-2 px-4 rounded-lg hover:bg-primary-hover mt-4"
                        >
                            Log In
                        </button>
                    </Form>
                </Formik>
                <div className="mt-4 text-center">
                    <button
                        onClick={() => {
                            toggleModal();
                            openForgotPasswordModal();
                        }}
                        className="text-sm text-primary hover:underline"
                    >
                        Forgot Password?
                    </button>
                </div>
            </div>
            {loading && <LoaderModal />}
        </div>
    );
};


export default LoginFormModal;
